import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { slugify } from 'Utils/Functions';

const WeekendWellness = ({ data }) => {
  const navigation = useNavigate();
  let { cityName } = useSelector((state) => state.location);
  cityName = slugify(cityName);

  const settings = {
    arrows: false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    lazyLoad: true,
    infinite: false,
    draggable: false,
    dots: false,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          dots: true
        }
      }
    ]
  };

  return (
    <div className="container">
      <div className="row">
        {data?.length > 0 && (
          <Slider
            {...settings}
            className="popular-health-content"
          >
            {data?.map((item, index) => (
              <div
                key={index}
                onClick={() =>
                  navigation(
                    `/${cityName}/health-packages/${item?.service_slug}`
                  )
                }
                className="benefit-card"
              >
                <figure className="unifit-image">
                  <img
                    src={item?.featured_image}
                    alt=""
                  />
                </figure>
              </div>
            ))}
          </Slider>
        )}
      </div>
    </div>
  );
};

export default WeekendWellness;
